






import { Component, Prop, Vue } from 'vue-property-decorator';
import Autocomplete from '@trevoreyre/autocomplete-vue';
import { General } from '../services/General';
import '@trevoreyre/autocomplete-vue/dist/style.css';
import axios from 'axios';

@Component({
    components: {
        Autocomplete
    }
})
export default class AutocompleteCustom extends Vue {
    @Prop()
    public url: string;

    @Prop({ default: true })
    public object: any;

    @Prop({ default: null, required: false })
    public defaultValue: string;

    @Prop()
    public result: any;

    @Prop()
    public placeHolder: string;

    @Prop({ default: true })
    public autoSelect: boolean;

    public value: string;

    resetItem() {
        this.$emit('selected', null, this.object);
    }

    reset() {
        this.$nextTick(() => {
            const inputElement = this.$refs.input as HTMLInputElement;
            if (inputElement) {
                inputElement.value = '';  
            }
        });
    }


    async search(input) {
        if (input != null && input != '') {
            let promise = await axios.get(General.GetApiUrl(this.url + '?filterText=' + input), { withCredentials: true });
            return promise.data;
        } else {
            let dataOutput = {
                data: []
            };
            let promiseDummy = await new Promise<IDataDummyOutput>((resolve) => {
                resolve(dataOutput);
            });
            return promiseDummy.data;
        }
    }

    submit(result) {
        this.value = result;
        // if(!this.objectRaw && this.objectRaw != undefined)
        this.$emit('selected', result, this.object);
        // else
        // this.$emit('selected', result);
    }
}
interface IDataDummyOutput {
    data: any[]
}


